import { action } from '@ember/object';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

import type { Args as DataManagerGridItemArgs } from 'webapp/components/data-manager/grid-item';
import DataManagerGridItemComponent from 'webapp/components/data-manager/grid-item';

interface Args extends DataManagerGridItemArgs {
	selectedItems?: string[];
}

export default class OnboardingCommonSourceItemComponent extends DataManagerGridItemComponent<Args> {
	@service('account') declare accountService: Service.Account;
	@service('infolayer') declare infolayerService: Service.Infolayer;

	override get extraClassNames(): string[] {
		const extraClassNames = [];

		if (this.isSelected) {
			extraClassNames.push('card--selected');
		}

		return extraClassNames;
	}

	override get isOverlayHidden(): boolean {
		return true;
	}

	get isSelected(): boolean {
		return (this.args.selectedItems || []).includes(this.args.model.key);
	}

	override get isChecked(): boolean {
		return false;
	}

	@action
	override triggerClick(): void {
		if (this.args.onClick) {
			this.args.onClick(this.args.model);
		}
	}
}
